import { render, staticRenderFns } from "./Controlview.vue?vue&type=template&id=ac050bfc&scoped=true"
import script from "./Controlview.vue?vue&type=script&lang=js"
export * from "./Controlview.vue?vue&type=script&lang=js"
import style0 from "./Controlview.vue?vue&type=style&index=0&id=ac050bfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac050bfc",
  null
  
)

export default component.exports